// @flow
import * as actions from 'modules/marketplace/recommended/duck/actions';
import type { MarketplaceProductKey } from 'modules/marketplace/data';
import type { Dispatch } from 'model/State';

export default (productKey: MarketplaceProductKey) => async (dispatch: Dispatch) => {
  await dispatch(actions.selectProduct(productKey));
  await dispatch(actions.fetch());
};
